<script>
import Layout from "../../layouts/main";
import { pieChart } from "./data-apex";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import axios from "axios";
import statusOptionsMixin from "@/mixins/statusOptions";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";
import { formatDate } from "@/helpers/dateFormatter";

export default {
  name: "SingleStaff",
  mixins: [statusOptionsMixin],

  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  data() {
    return {
      Email: null,
      first_name: null,
      last_name: null,
      status: null,
      applicantNum: [],
      assignPrsn: [],
      dateLog: [],
      statusLog: [],

      total_approved: 0,
      total_reject: 0,
      total_incomplete: 0,
      pieChart: pieChart,
      searchValueTable: "",
      selectFilterSort: null,
      headers: [
        { text: "Applicant Number", value: "applicantNum" },
        { text: "Assign", value: "assignPrsn" },
        { text: "Date", value: "dateLog" },
        { text: "Status", value: "statusLog" },
      ],
      items: [],
      arrItem: [],

      // presentation only: skeletons + client-side paging for the footer
      loading: true,
      page: 1,
      rowsPerPage: 10,
    };
  },
  computed: {
    fullName() {
      return `${this.first_name || ""} ${this.last_name || ""}`.trim() || "N/A";
    },
    statusSelectOptions() {
      return [
        { value: null, label: "All Status" },
        ...this.statusFilterOptions.map((o) => ({ value: o.key, label: o.label })),
      ];
    },
    pagedItems() {
      const start = (this.page - 1) * this.rowsPerPage;
      return this.arrItem.slice(start, start + this.rowsPerPage);
    },
  },
  created() {
    this.get_staff_data();
  },
  methods: {
    formatDate,
    staffTone(status) {
      return { Active: "green", Inactive: "blue" }[status] || "red";
    },
    onPageChange(page) {
      this.page = page;
    },
    onRowsChange(rowsPerPage) {
      this.rowsPerPage = rowsPerPage;
      this.page = 1;
    },
    filterStatus() {
      if (!this.selectFilterSort || this.selectFilterSort === "all") {
        this.arrItem = [...(this.items || [])];
      } else {
        // strict match on the backend status key
        this.arrItem = (this.items || []).filter(
          (item) => item.statusLog === this.selectFilterSort,
        );
      }
      this.page = 1;
    },
    get_staff_data() {
      let arrList = [];
      var app = window.location.href;
      const segments = app.split("/");
      const app_id = segments[segments.length - 1];

      axios
        .post("/applications/single_user_details/", { app_id: app_id })
        .then((response) => {
          const data = response.data.user_email;
          (this.first_name = data.first_name),
            (this.last_name = data.last_name),
            (this.status = data.staff_status);
          this.Email = data.email;
          this.total_approved = response.data.approved_status;
          this.total_reject = response.data.rejected_status;
          let responseList = response.data.user_datw;
          responseList.forEach((item) => {
            let newItem = {
              applicantNum:
                item.application_no ||
                `ECU-${String(item.id).padStart(6, "0")}`,
              assignPrsn: item.rev || item.curr_reviewer || "N/A",
              dateLog: item.created_on,
              statusLog: item.status,
            };
            // Push the transformed item to the existing array
            arrList.push(newItem);
          });
          // the filter works on `items`; it was never filled, so any status
          // other than "All" produced an empty table
          this.items = arrList;
          this.filterStatus();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="sdetail">
      <header class="ecu-page-head">
        <div>
          <span class="ecu-page-head__bar"></span>
          <h1>Staff Details</h1>
          <p class="ecu-page-head__sub">
            Profile and review activity of this staff member.
          </p>
        </div>
        <router-link to="/staff_users" class="ecu-text-link">
          <AppIcon name="chevron-left" :size="16" :stroke="2.2" />
          Staff Users
        </router-link>
      </header>

      <div class="ecu-detail">
        <!-- profile -->
        <aside class="ecu-card">
          <div class="ecu-profile">
            <span class="ecu-profile__avatar">
              <img
                src="../../../assets/images/users/stafffour.png"
                alt="Staff member"
              />
            </span>
            <h2 class="ecu-profile__name">
              <span
                v-if="loading"
                class="ecu-skeleton ecu-info__sk"
                aria-hidden="true"
              ></span>
              <template v-else>{{ fullName }}</template>
            </h2>
            <span class="ecu-profile__role">Staff Member</span>
          </div>

          <div class="ecu-stat-pair">
            <div class="ecu-stat-pair__item">
              <span class="ecu-stat-pair__icon ecu-stat-pair__icon--ok">
                <AppIcon name="check-circle" :size="20" />
              </span>
              <span>
                <strong>{{ total_approved }}</strong>
                <small>Approved</small>
              </span>
            </div>
            <div class="ecu-stat-pair__item">
              <span class="ecu-stat-pair__icon ecu-stat-pair__icon--bad">
                <AppIcon name="x-circle" :size="20" />
              </span>
              <span>
                <strong>{{ total_reject }}</strong>
                <small>Rejected</small>
              </span>
            </div>
          </div>

          <ul class="ecu-info">
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="mail" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Email</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ Email || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="user" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">First Name</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ first_name || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon"><AppIcon name="user" :size="18" /></span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Last Name</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <template v-else>{{ last_name || "N/A" }}</template>
                </span>
              </span>
            </li>
            <li class="ecu-info__item">
              <span class="ecu-info__icon">
                <AppIcon name="shield-check" :size="18" />
              </span>
              <span class="ecu-info__text">
                <span class="ecu-info__label">Status</span>
                <span class="ecu-info__value">
                  <span v-if="loading" class="ecu-skeleton ecu-info__sk"></span>
                  <StatusChip
                    v-else-if="status"
                    :label="`${status}`"
                    :tone="staffTone(`${status}`)"
                  />
                  <template v-else>N/A</template>
                </span>
              </span>
            </li>
          </ul>
        </aside>

        <!-- related applications -->
        <div class="ecu-card">
          <div class="ecu-toolbar ecu-toolbar--stacked">
            <div class="ecu-card__head">
              <span class="ecu-tile"><AppIcon name="file" :size="20" /></span>
              <h2 class="ecu-card__title">Related Applications</h2>
            </div>

            <div class="ecu-toolbar__row">
              <EcuSelect
                v-model="selectFilterSort"
                class="ecu-filter-select"
                :options="statusSelectOptions"
                aria-label="Filter by status"
                @change="filterStatus"
              />
              <a href="javascript:void(0);" class="ecu-btn-add">Download CSV</a>
            </div>
          </div>

          <div class="ecu-table-wrap">
            <EasyDataTable
              :headers="headers"
              :items="pagedItems"
              :search-value="searchValueTable"
              :loading="loading"
              :rows-per-page="rowsPerPage"
              empty-message="No related applications found"
              theme-color="#f97316"
              hide-footer
              table-class-name="table-custom-style noWrapHeading"
            >
              <template #item-applicantNum="{ applicantNum }">
                <span class="ecu-strong">{{ applicantNum }}</span>
              </template>
              <template #item-dateLog="{ dateLog }">
                <span class="ecu-date">
                  <AppIcon name="calendar" :size="16" />
                  {{ formatDate(dateLog) }}
                </span>
              </template>
              <template #item-statusLog="{ statusLog }">
                <StatusChip :status="statusLog" />
              </template>
            </EasyDataTable>
          </div>

          <TableFooter
            :page="page"
            :rows-per-page="rowsPerPage"
            :total="arrItem.length"
            :loading="loading"
            @update:page="onPageChange"
            @update:rowsPerPage="onRowsChange"
          />
        </div>
      </div>
    </section>
  </Layout>
</template>

<style scoped>
.sdetail {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.sdetail .ecu-page-head {
  margin-bottom: 0;
}
.sdetail .ecu-card {
  padding: 22px 22px 18px;
}
.sdetail .ecu-toolbar .ecu-tile {
  background: transparent;
}
@media (max-width: 767px) {
  .sdetail .ecu-card {
    padding: 16px 14px 14px;
  }
}
</style>